var exports = {
  "i": "xaee3c4fa--8ba023--wrapper",
};

module.exports = exports;
